module.exports = __webpack_public_path__ + "img/ssRecentSearch.b5cee446.svg";